export default __webpack_public_path__ + "static/media/40-41.a5ba26d7.png";